import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RemoveStockedItemsFilter } from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";

type HandlerType = HandlerWithResult<ProductFilters, ProductFilters>;

export const ThosRemoveStockedItemsFilter: HandlerType = ({ result, parameter: { stockedItemsOnly } }) => {
    if (stockedItemsOnly !== undefined) {
         result.stockedItemsOnly = stockedItemsOnly;
    }
};

replaceInChain(chain, RemoveStockedItemsFilter, ThosRemoveStockedItemsFilter);